import {Functions} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import FeatureUsage from './FeatureUsage';

export const featureUsage: FeatureObject = {
  type: 'settings',
  title: 'Feature Usage',
  description: 'Manage your feature usage',
  IconComponent: Functions,
  path: '/featureUsage',
  component: () => <FeatureUsage />,
  status: FeatureStatus.PROD,
};
